import {MNullable} from '../Toolkit/Utils';
import * as Yup from 'yup';

export class SafeDigTask {
    public safeDigTasksId: number = 0;
    public taskStatus: number = 0;
    public createdOn: MNullable<Date> = null;
    public completedDate: MNullable<Date> = null;
    public modifiedDate: MNullable<Date> = null;
    public taskSubType: number = 0;
    public safeDigsId: number = 0;
    public taskType: number = 0;
    public comment: string = '';
    public dueDate: MNullable<Date> = null;

    //public auditLogEntitys: MNullable<AuditEntry[]> = null;
}

export class CreateSafeDigTaskValidator {
    public static readonly title = Yup.string().label('Title').max(50).required();
    public static readonly comment = Yup.string().label('Comment').max(255).optional();
}

export class UpdateSafeDigValidator {
    public static readonly title = Yup.string().label('Title').max(50).required();
    public static readonly comment = Yup.string().label('Comment').max(255).optional();
}

export class SafeDigTaskReply {
    public data: MNullable<SafeDigTask> = null;
}

export class SafeDigTaskListReply {
    public data: SafeDigTask[] = [];
}

export class CountSafeDigTasksReply {
    public value: number = 0;
    public statusCode: number = 0;
    public message: string = '';
}

export class CreateSafeDigTaskReply {
    public data: MNullable<SafeDigTask> = null;
    public statusCode: number = 0;
    public message: string = '';
}

export class UpdateSafeDigTaskReply {
    public value: number = 0;
    public statusCode: number = 0;
    public message: string = '';
}